<template>
  <v-dialog v-model="showDialog" :max-width="maxWidth">
    <v-card>
      <v-toolbar flat dark color="primary">
        <v-toolbar-title class="font-weight-medium">
          {{ title }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6 px-4" style="font-size: 1rem">
        <slot />
      </v-card-text>
      <v-divider />
      <v-card-actions v-show="!hideActions">
        <v-btn class="cancel" text @click="$emit('cancel')">Cancel</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="disabled"
          @click="$emit('submit')"
        >
          {{ submitBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

export default mixins(DialogMixin).extend({
  name: 'ConfirmationDialog',

  props: {
    title: {
      type: String,
      default: 'Please Confirm Your Action',
    },
    submitBtnText: {
      type: String,
      default: 'Confirm',
    },
    hideActions: Boolean,
    loading: Boolean,
    disabled: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 600,
    },
  }
})
</script>
